import Vue from "vue";

const state = {
  shipmentProfiles: [],
  total: 0,
  profile: {
    name: "",
    method: "",
    countries: []
  }
};

const getters = {};

const actions = {
  LOAD_SHIPMENT_PROFILES: function({ commit }, payload) {
    let nameQuery = payload.name ? "&name=" + payload.name : "";
    let idQuery = payload.id ? "&id=" + payload.id : "";
    let methodQuery = payload.method ? "&method=" + payload.method : "";
    return Vue.prototype.$axios
      .get(
        "shipments/profiles?from=" +
          payload.from +
          "&limit=" +
          payload.to +
          nameQuery +
          idQuery +
          methodQuery
      )
      .then(response => {
        commit("SET_SHIPMENT_PROFILES", response.data.shipmentProfiles);
        commit("SET_TOTAL", response.data.meta.total);
      });
  },
  LOAD_SHIPMENT_PROFILE: function({ commit }, payload) {
    return Vue.prototype.$axios
      .get("shipments/profiles/" + payload)
      .then(response => {
        commit("SET_SHIPMENT_PROFILE", response.data.shipmentProfile);
      });
  },
  CREATE_SHIPMENT_PROFILE: async function(context, payload) {
    return await Vue.prototype.$axios.post("shipments/profiles", payload);
  },
  UPDATE_SHIPMENT_PROFILE: async function(context, payload) {
    return await Vue.prototype.$axios.post(
      "shipments/profiles/" + payload.id,
      payload
    );
  },
  DESTROY_SHIPMENTPROFILE: async function(context, payload) {
    return await Vue.prototype.$axios.delete("shipments/profiles/" + payload);
  }
};

const mutations = {
  SET_SHIPMENT_PROFILES: function(state, payload) {
    state.shipmentProfiles = payload;
  },
  SET_SHIPMENT_PROFILE: function(state, payload) {
    state.profile = payload;
  },
  SET_TOTAL: function(state, payload) {
    state.total = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
